import React, { useEffect, useState } from "react";
import UserLayout from "../layout/UserLayout";

const ITEMS_PER_PAGE = 12;

const TeaProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetch("https://ceymoslanka.com/backend/api/tea_manager/get_tea_products.php")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const current = products.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <UserLayout>
      <div className="max-w-6xl mx-auto px-4 pt-24 pb-16">

        <h1 className="text-4xl font-bold text-gray-900">Ceylon Tea</h1>
        <div className="w-20 h-[3px] bg-gray-900 mt-1 mb-6"></div>

        <p className="text-gray-700 text-lg w-full mb-4">
          Ceylon Tea is globally recognized for its
          <span className="font-semibold text-[#C8A951]"> rich aroma</span>,
          <span className="font-semibold text-[#C8A951]">bright taste</span>,
          and exceptional purity. Sourced from the mist-covered highlands of Sri Lanka,
          every leaf is carefully handpicked to ensure unmatched freshness, depth of flavor,
          and premium quality that stands among the world’s finest teas.
        </p>

        <p className="text-gray-700 text-base w-full mb-6">
          The unique combination of high elevation, tropical climate, fertile soil,
          and centuries of tea-making expertise has made Ceylon Tea a symbol of
          <span className="italic text-[#C8A951]">authenticity</span>,
          <span className="italic text-[#C8A951]">heritage</span>,
          and <span className="italic text-[#C8A951]">excellence</span>.
          Each cup carries the legacy of Sri Lanka’s renowned tea regions—from the brisk,
          lively notes of Nuwara Eliya to the bold, full-bodied character of Ruhuna.
        </p>

        <ul className="text-gray-700 text-base w-full mb-10 list-disc list-inside space-y-2">
          <li>
            <span className="font-semibold text-[#C8A951]">Grown at ideal elevations</span>
            that naturally enhance flavor, aroma, and clarity.
          </li>

          <li>
            <span className="font-semibold text-[#C8A951]">Handpicked at peak freshness</span>
            and expertly processed for consistent high quality.
          </li>

          <li>
            Rich in <span className="font-semibold text-[#C8A951]">antioxidants</span>
            that support immunity, heart health, and overall well-being.
          </li>

          <li>
            Available in a wide range of <span className="font-semibold text-[#C8A951]">grades and varieties</span>
            to suit every taste preference—from crisp black teas to aromatic blends.
          </li>

          <li>
            A <span className="italic text-[#C8A951]">timeless Sri Lankan tradition</span> enjoyed by tea lovers across the globe.
          </li>
        </ul>

        <p className="text-gray-700 text-base w-full mb-12">
          At Ceymos Lanka, we bring you a curated selection of premium Ceylon teas that reflect the
          island’s authentic character and craftsmanship. Each product is freshly packed with careful attention
          to purity, consistency, and natural taste—allowing you to experience the
          <span className="font-semibold text-[#C8A951]">true essence of Sri Lankan tea</span>
          in every cup.
        </p>





        {loading ? (
          <p className="text-center text-gray-600">Loading tea products...</p>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">

              {current.map((p) => (
                <a
                  key={p.id}
                  href={`/tea/${p.id}`}
                  className="border rounded-lg bg-white shadow-sm hover:shadow-md transition block"
                >
                  <img
                    src={
                      p.image
                        ? `https://ceymoslanka.com/backend/uploads/tea_products/${p.image}`
                        : "https://via.placeholder.com/400x300?text=No+Image"
                    }
                    alt={p.title}
                    className="w-full h-56 object-cover rounded-t-lg"
                  />

                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-900">
                      {p.title}
                    </h3>

                    <p className="text-gray-800 font-medium mt-3">
                      Net Weight: {p.net_weight}
                    </p>
                  </div>
                </a>
              ))}

            </div>

            <div className="flex justify-center gap-2 mt-10">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <button
                  key={num}
                  onClick={() => setPage(num)}
                  className={
                    num === page
                      ? "px-4 py-2 border border-gray-800 rounded text-gray-900 font-semibold"
                      : "px-4 py-2 border rounded text-gray-600 hover:bg-gray-100"
                  }
                >
                  {num}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </UserLayout>
  );
};

export default TeaProducts;
